import { application } from "./application"

import AutoResolutionSettingsController from "./auto_resolution_settings_controller"
import ClipboardController from "./clipboard_controller"
import CmdSubmitController from "./cmd_submit_controller"
import CommentReplyController from "./comment_reply_controller"
import EmojiPickerController from "./emoji_picker_controller"
import CollapsibleController from "./collapsible_controller"
import ComboboxController from "./combobox_controller"
import DialogController from "./dialog_controller"
import DropdownController from "./dropdown_controller"
import InboxController from "./inbox_controller"
import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
import PostFilterController from "./post_filter_controller"
import SidebarController from "./sidebar_controller"
import ThreadFilterController from "./thread_filter_controller"
import ThemeToggleController from "./theme_toggle_controller"
import TiptapController from "./tiptap_controller"
import NewPostModalController from "./new_post_modal_controller"
import OsNotificationsController from "./os_notifications_controller"
import SelectController from "./select_controller"

application.register("auto-resolution-settings", AutoResolutionSettingsController)
application.register("clipboard", ClipboardController)
application.register("cmd-submit", CmdSubmitController)
application.register("comment-reply", CommentReplyController)
application.register("emoji-picker", EmojiPickerController)
application.register("collapsible", CollapsibleController)
application.register("combobox", ComboboxController)
application.register("dialog", DialogController)
application.register("dropdown", DropdownController)
application.register("inbox", InboxController)
application.register("keyboard-shortcuts", KeyboardShortcutsController)
application.register("new-post-modal", NewPostModalController)
application.register("post-filter", PostFilterController)
application.register("sidebar", SidebarController)
application.register("thread-filter", ThreadFilterController)
application.register("theme-toggle", ThemeToggleController)
application.register("tiptap", TiptapController)
application.register("os-notifications", OsNotificationsController)
application.register("select", SelectController)
